export const environment = {
  environmentName: 'test',
  production: true,

  backend: {
    baseUrl: 'https://niclen-app-tm-test-dewest.azurewebsites.net',
    apiUrl: '/api/',
  },
  azureActiveDirectory: {
    authorityDomain: 'login.microsoftonline.com',
    clientId: '8ecdcfdc-4734-4e16-813e-96e2780805c0',
    scopes: ['api://871e129f-790e-45ef-89d6-4854d30bf61e/niclen.access'],
    authorities: {
      signUpSignIn: 'https://login.microsoftonline.com/niclen.de',
      acquireToken: 'https://login.microsoftonline.com/niclen.de',
    },
  },
  appInsights: {
    instrumentationKey: '',
  },
};
